import Decimal from "decimal.js";
import { useEffect, useRef } from "react";
import { multiplierModel, serverNow } from "../../net/connection.js";

/**
 * Running payout inside the cashout button, updated from rAF for the same
 * reason as the multiplier: no React render per frame.
 */
export function LiveWin({ amount, decimals = 2 }: { amount: number; decimals?: number }) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    let frame = 0;
    let last = "";
    const tick = () => {
      const el = ref.current;
      if (el !== null) {
        const text = new Decimal(amount).mul(multiplierModel.valueAt(serverNow())).toFixed(decimals);
        if (text !== last) {
          el.textContent = text;
          last = text;
        }
      }
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(frame);
    };
  }, [amount, decimals]);

  return <span ref={ref}>{amount.toFixed(decimals)}</span>;
}
